import { apiSlice } from "../api/apiSlice";

export const assignmentMarksApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAssignmentMarks: builder.query({
            query: () => `/assignmentMark`,
        }),
        getAssignmentMarksByStudent: builder.query({
            query: ({ studentId, title }) => `/assignmentMark?student_id=${studentId}&title=${title}`,
            providesTags:['getAssignmentMarksByStudent']
        }),

        getAssignmentMark: builder.query({
            query: (id) => `/assignmentMark?id=${id}`,
        }),

        addAssignmentMarks: builder.mutation({
            query: (data) => ({
                url: "/assignmentMark",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const res = await queryFulfilled;
                    if (res?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData("getAssignmentMarks", undefined, draft => {
                                draft.push(res?.data)
                            })
                        )
                    }
                } catch (err) {

                }
            },
            invalidatesTags:['getAssignmentMarksByStudent']
        }),

        editAssignmentMark: builder.mutation({
            query: ({ id, data }) => ({
                url: `/assignmentMark/${id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const res = await queryFulfilled;
                    if (res?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData("getAssignmentMarks", undefined, draft => {
                                const index = draft.findIndex(v => v.id == arg.id);
                                draft[index] = res?.data;
                            })
                        );

                        dispatch(
                            apiSlice.util.updateQueryData("getAssignmentMark", arg.id, draft => {
                                const index = draft.findIndex(v => v.id == arg.id);
                                draft[index] = res?.data;
                            })
                        );


                    }
                } catch (err) {

                }
            },
        })
    }),
});

export const {
    useGetAssignmentMarkQuery,
    useGetAssignmentMarksQuery,
    useAddAssignmentMarksMutation,
    useEditAssignmentMarkMutation,
    useGetAssignmentMarksByStudentQuery
} = assignmentMarksApi;
